import React from 'react'
import './contact.css'
import '@fortawesome/fontawesome-free/css/all.min.css';


export default function contact() {
  return (
    <div>
      
      <div class="contact">
           
  <a href="mailto:kaveeshabwic089@gmail.com" target="_blank" rel="noreferrer" class="contact-link" >Mail <br/> <i className="fas fa-envelope"></i> </a>
  <a href="https://www.linkedin.com/in/buthmi-wick/" target="_blank" rel="noreferrer" class="contact-link">LinkedIn <br/> <i className="fab fa-linkedin"></i> </a>
  <a href="https://github.com/ButhmiK" target="_blank"  rel="noreferrer" class="contact-link">GitHub <br/> <i className="fa-brands fa-github"></i></a>
  <a href="https://www.behance.net/buthmikwi" target="_blank" rel="noreferrer" class="contact-link">Behance <br/><i className="fab fa-behance"></i> </a>
  <a href="https://dribbble.com/yourprofile" target="_blank" rel="noreferrer" class="contact-link">Dribble <br/><i className="fab fa-dribbble"></i> </a>
  <a href="https://buthmi-k-wick.netlify.app/" target="_blank" rel="noreferrer" class="contact-link">My Portfolio <br/> <i className="fas fa-globe"></i> </a>
  
  



    </div>
    </div>
  )
}
